/**
 * Operations Department navigation items.
 * Module names use department prefix (operations/..., operations/bpo/...) for role- and department-based permissions.
 * alternativeModules allow legacy module names to grant access so subpoints display for existing roles.
 */
const operationsNavigation = [
  { path: '/shops', label: 'Shop Management', module: 'operations/Shop Management', alternativeModules: ['Shop Management'] },
  { path: '/shopfees', label: 'Platform & Delivery Fees Management', module: 'operations/Shop Fees', alternativeModules: ['Shop Fees'] },
  { path: '/subscription', label: 'Subscription Plans Management', module: 'operations/Subscription Plans', alternativeModules: ['Subscription Plans'] },
  { path: '/hsn', label: 'HSN Codes Management', module: 'operations/HSN Codes', alternativeModules: ['HSN Codes'] },
  { path: '/gst-settings', label: 'Changing of GST Type', module: 'operations/GST Type', alternativeModules: ['Operations'] },
  {
    path: '/operations/bpo',
    label: 'BPO',
    isParent: true,
    subItems: [
      { path: '/', label: 'Order Management Screen', module: 'operations/bpo/orders', alternativeModules: ['orders', 'Order Details'] },
      {
        path: '/service-bookings',
        label: 'Service Booking Management',
        module: 'operations/bpo/service-bookings',
        alternativeModules: ['Service Bookings', 'orders', 'Order Details', 'operations/bpo/orders']
      },
      {
        label: 'Onboarding',
        isParent: true,
        subItems: [
          { path: '/incoming-applications', label: 'Incoming Applications', module: 'operations/bpo/onboarding/Incoming Applications', alternativeModules: ['Incoming Applications'] },
          { path: '/status/accepted', label: 'Accepted Applications', module: 'operations/bpo/onboarding/Accepted Applications', alternativeModules: ['Accepted Applications'] },
          { path: '/status/rejected', label: 'Rejected Applications', module: 'operations/bpo/onboarding/Rejected Applications', alternativeModules: ['Rejected Applications'] }
        ]
      },
      {
        label: 'Users Management',
        isParent: true,
        subItems: [
          { path: '/userApp', label: 'KD Users', module: 'operations/bpo/users/KD Users', alternativeModules: ['KD Users'] },
          {
            label: 'KDP Users',
            isParent: true,
            subItems: [
              { path: '/kdpusers?role=ShopOwner', label: 'Shop Owners', module: 'operations/bpo/users/KDP Users', alternativeModules: ['KDP Users'] },
              { path: '/kdpusers?role=DeliveryBoy', label: 'Delivery Boys', module: 'operations/bpo/users/KDP Users', alternativeModules: ['KDP Users'] },
              { path: '/kdpusers?role=ShopMember', label: 'Shop Members', module: 'operations/bpo/users/KDP Users', alternativeModules: ['KDP Users'] },
              { path: '/kdpusers?role=Admin', label: 'Admins', module: 'operations/bpo/users/KDP Users', alternativeModules: ['KDP Users'] },
              { path: '/kdpusers?role=Guest', label: 'Guests', module: 'operations/bpo/users/KDP Users', alternativeModules: ['KDP Users'] }
            ]
          }
        ]
      },
      {
        label: 'Blogger',
        isParent: true,
        subItems: [
          {
            path: '/blogger?tab=bloggers',
            label: 'All bloggers',
            module: 'operations/Blogger',
            alternativeModules: [
              'operations/Shop Management',
              'Shop Management',
              'operations/bpo/support/Support Tickets',
              'Support Tickets'
            ]
          },
          {
            path: '/blogger?tab=tasks',
            label: 'Content tasks',
            module: 'operations/Blogger',
            alternativeModules: [
              'operations/Shop Management',
              'Shop Management',
              'operations/bpo/support/Support Tickets',
              'Support Tickets'
            ]
          },
          {
            path: '/blogger?tab=posts',
            label: 'Blog posts',
            module: 'operations/Blogger',
            alternativeModules: [
              'operations/Shop Management',
              'Shop Management',
              'operations/bpo/support/Support Tickets',
              'Support Tickets'
            ]
          }
        ]
      },
      {
        label: 'Field Boy',
        isParent: true,
        subItems: [
          {
            path: '/field-boy?tab=field-boys',
            label: 'Field Boys & shops',
            module: 'operations/Field Boy',
            alternativeModules: [
              'operations/Shop Management',
              'Shop Management',
              'operations/bpo/support/Support Tickets',
              'Support Tickets'
            ]
          },
          {
            path: '/field-boy?tab=visits',
            label: 'Visits',
            module: 'operations/Field Boy',
            alternativeModules: [
              'operations/Shop Management',
              'Shop Management',
              'operations/bpo/support/Support Tickets',
              'Support Tickets'
            ]
          },
          {
            path: '/field-boy?tab=tasks',
            label: 'Field tasks',
            module: 'operations/Field Boy',
            alternativeModules: [
              'operations/Shop Management',
              'Shop Management',
              'operations/bpo/support/Support Tickets',
              'Support Tickets'
            ]
          },
          {
            path: '/field-boy?tab=issues',
            label: 'Issues & tickets',
            module: 'operations/Field Boy',
            alternativeModules: [
              'operations/Shop Management',
              'Shop Management',
              'operations/bpo/support/Support Tickets',
              'Support Tickets'
            ]
          }
        ]
      },
      {
        label: 'Apps Management',
        isParent: true,
        subItems: [
          { path: '/size-chart', label: 'Size Chart', module: 'operations/bpo/apps/Size Charts', alternativeModules: ['Size Charts'] },
          { path: '/tutorial', label: 'App Tutorials', module: 'operations/bpo/apps/Tutorials', alternativeModules: ['Tutorials'] },
          { path: '/hsn', label: 'HSN', module: 'operations/bpo/apps/HSN Codes', alternativeModules: ['HSN Codes'] },
          { path: '/announcements', label: 'Announcements', module: 'operations/bpo/apps/Announcements', alternativeModules: ['Announcements'] },
          { path: '/category', label: 'Categories', module: 'operations/bpo/apps/Categories', alternativeModules: ['Categories'] },
          { path: '/service-category-management', label: 'Service Categories', module: 'operations/bpo/apps/Service Categories', alternativeModules: ['Service Categories'] }
        ]
      },
      {
        label: 'KD Support Team',
        isParent: true,
        subItems: [
          { path: '/support', label: 'App Support Tickets', module: 'operations/bpo/support/Support Tickets', alternativeModules: ['Support Tickets'] },
          { path: '/contact', label: 'Contact Us Website Tickets', module: 'operations/bpo/support/Contact Forms', alternativeModules: ['Contact Forms'] },
          { path: '/customer-suggestions', label: 'KD Customer suggestions', module: 'operations/bpo/support/Customer Suggestions', alternativeModules: ['Customer Suggestions'] }
        ]
      },
      {
        label: 'KDP Support team',
        isParent: true,
        subItems: [
          { path: '/support', label: 'Support Tickets', module: 'operations/bpo/kdpsupport/Support Tickets', alternativeModules: ['Support Tickets'] },
          { path: '/contact', label: 'Contact Us Tickets', module: 'operations/bpo/kdpsupport/Contact Forms', alternativeModules: ['Contact Forms'] }
        ]
      }
    ]
  }
];

export default operationsNavigation;
